
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface AllergyParameters extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Allergy {
    id?: number;
    snomedCode: number;
    name: string;
    univ_Code?:string;
  parameters?: AllergyParameters[];
  links?: any;
  mappingAttribute?:string;
}

export abstract class AllergyData {

  abstract list(url: string): Observable<Allergy[]>;
  abstract create(url: string, data: Allergy): Observable<any>;
  abstract update(url: string, data: Allergy): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract createDataLoad(url: string, data: any[]): Observable<any>;

}
